export default {
  title: "Services",
  laundry: {
    title: "Service de blanchisserie",
    free: "Gratuit",
    washing_machine: "Machine à laver",
    dryer: "Sèche-linge",
    per_cycle: "/ cycle",
    pay_and_start: "Payer & Démarrer",
    in_use: "En cours d’utilisation",
    location: "Buanderie située au 1er étage, chambre 105"
  },
  reductions: {
    title: "Réductions actives",
    subtitle: "Économisez davantage sur votre réservation avec ces offres",
    valid_until: "Valable jusqu’au",
    auto_apply: "Appliqué automatiquement",
    note: "Voici les réductions actuellement actives. Des conditions de réservation supplémentaires peuvent s’appliquer.",
    expiring_soon: "Expire bientôt",
    valid_for_buildings: "Valable pour :",
    valid_for_all_buildings: "Valable pour tous les bâtiments",
    max_occupancy: "Nombre max. de personnes :",
    selected_unit_types: "Valable uniquement pour certains types de chambres",
    stay: "Séjour :",
    stay_from: "Séjour à partir de",
    days: "jours",
    travel_dates: "Dates de voyage :",
    travel_from: "Voyage à partir de :",
    travel_until: "Voyage jusqu’au :",
    use_once_per_guest: "Peut être utilisé une fois par client",
    use_up_to: "Peut être utilisé jusqu’à",
    times_per_guest: "fois par client",
    manual_code: "Le code promo doit éventuellement être saisi manuellement",
    description_percentage: "Réduction en pourcentage",
    description_fixed_amount: "Réduction à montant fixe",
    description_free_night: "Offre de nuit gratuite",
    description_free_nights: "Offre de nuit gratuite",
    description_free_option: "Offre d’option gratuite",
    description_default: "Réduction",
    available_count: "promotions disponibles",
    code_copied: "Code promo copié",
    code_copy_failed: "Impossible de copier le code promo",
    tap_to_copy: "Appuyez sur une promotion pour copier le code",
    book_now: "Réserver",
    view_buildings: "Voir les bâtiments"
  },
  extras: {
    title: "Améliorez votre séjour",
    add: "Ajouter"
  },
  cleaning: {
    title: "Services de nettoyage",
    intro: "Réservez du matériel de nettoyage et récupérez-le à la réception avant de nettoyer votre studio.",
    pickup: "À récupérer à la réception",
    reserve: "Réserver",
    free: "Gratuit",
    kit_note: "Vous préférez votre propre matériel ? Des kits de nettoyage sont aussi disponibles à l’achat à la réception."
  },
  faq: {
    title: "FAQ",
    search_label: "Rechercher une question...",
    no_results: "Aucune FAQ ne correspond à votre recherche.",
    select_building: "Sélectionnez votre bâtiment",
    select_building_first: "Sélectionnez un bâtiment pour consulter les questions fréquentes."
  },
  support: {
    title: "Assistance",
    sales: {
      title: "Appeler le service commercial",
      subtitle: "Joignable maintenant au "
    },
    call: {
      title: "Appeler le gestionnaire de la résidence"
    },
    chat: {
      title: "Chat en direct",
      subtitle: "Réponse rapide"
    },
    directions: {
      title: "Itinéraire",
      subtitle: "Naviguer vers l'hôtel",
      url: "https://maps.google.com"
    },
    emergency: {
      title: "Contact d’urgence",
      subtitle: "À appeler uniquement en cas d’urgence."
    }
  }
};
